<div *ngIf="vademecum">
  Health problems:
  <div *ngFor="let problem of healthProblems">
    {{problem}}
  </div>
  <div>
    Birth date: {{vademecum.birthDate}}
  </div>
  <div>
    Blood type: {{vademecum.bloodType.name}}
  </div>
  <div>
    Emergency contact: {{vademecum.emergencyContactAddress}}
  </div>
  <div>
    <!-- Emergency phone (daytime): {{vademecum.emergencyPhoneNumber}} -->
  </div>
  <div>
    <!-- Emergency phone (evening): {{vademecum.emergencyEveningPhoneNumber}} -->
  </div>
  <div>
    <!-- Phone number: {{vademecum.phoneNumber}} -->
  </div>
  <div>
    Selected language: {{vademecum.targetLanguage.name | titlecase}}
  </div>
</div>